import m, {Vnode} from "mithril";
import {ImageItem} from "../../../../model/items/imageItem";
import {LabelItem} from "../../../../model/items/labelItem";
import {TextboxItem} from "../../../../model/items/textbox";
import Cell from "../../../../model/form/cell";
import Image from "../../../shared/components/Image/Image";
import LabelCell from "../../../shared/components/FormCell/LabelCell";
import KandidatiControls from "./KandidatiControls";
import KandidatiDefault from "../KandidatiDefault";

type TKandidatiRow = {
    image: ImageItem,
    name: LabelItem,
    description: LabelItem,
    input: TextboxItem
};

export default class KandidatDefault {

    public static parseRow(row: Cell[]): TKandidatiRow {
        if (row?.length < 4) {
            throw new Error("Expect row includes 4 or more items.")
        }
        const image = row[0]?.getItems()[0];
        const name = row[1]?.getItems()[0];
        const description = row[2]?.getItems()[0];
        const input = row[3]?.getItems()[0];

        if (image instanceof ImageItem && name instanceof LabelItem && description instanceof LabelItem && input instanceof TextboxItem) {
            return {image, name, description, input};
        }
        throw new Error("Expects row: Image, Label, Label, Textbox, ...any.")
    }

    private readonly image: Image;
    private readonly name: LabelCell;
    private readonly description: LabelCell;
    private readonly controls: KandidatiControls;

    constructor(
        private readonly row: TKandidatiRow,
        public readonly kandidati: KandidatiDefault
    ) {
        this.image = new Image(row.image);
        this.name = new LabelCell(row.name);
        this.description = new LabelCell(row.description);
        this.controls = new KandidatiControls(row.input, this);
    }

    public getValue(): number {
        return this.controls.getValue();
    }

    public view(): Vnode {

        return m('.kandidat'+(this.controls.isFocused()?'.focused':''), {}, [
            m(this.name),
            m('.kandidat-image', {}, [
                m(this.image),
                m(this.description),
            ]),
            m(this.controls),
            this.kandidati.viewRestDiff('kandidat-status'),
        ]);
    }
}